import React from 'react';
import PropTypes from 'prop-types';

import withRsSlidableNavigationHandlers from '@Pages/RetroSynthesis/components/RsSlidable/HOCs/withSlidableNavigationHandlers';
import RsSlidableNavigationPrev from '@Pages/RetroSynthesis/components/RsSlidable/RsSlidableNavigationPrev';
import RsSlidableNavigationNext from '@Pages/RetroSynthesis/components/RsSlidable/RsSlidableNavigationNext';

function RsSlidableNavigationRightSide({ prevDisabled, nextDisabled, goPrev, goNext }) {
  return (
    <div className="rs-slidable-navigation rs-slidable-navigation--right-side">
      <RsSlidableNavigationPrev disabled={prevDisabled} onClick={goPrev} />
      <RsSlidableNavigationNext disabled={nextDisabled} onClick={goNext} />
    </div>
  );
}

RsSlidableNavigationRightSide.defaultProps = {
  goPrev: () => {},
  goNext: () => {},
};

RsSlidableNavigationRightSide.propTypes = {
  prevDisabled: PropTypes.bool,
  nextDisabled: PropTypes.bool,
  goPrev: PropTypes.func,
  goNext: PropTypes.func,
};

export default withRsSlidableNavigationHandlers()(RsSlidableNavigationRightSide);
